module.exports = __webpack_public_path__ + "static/img/product_banner_46_zh.5a7faf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_46_zh.png
// module id = YrAc
// module chunks = 34